import { EnvironmentProviders, inject, provideEnvironmentInitializer } from '@angular/core';
import { VersionIntroStore } from './version-intro.store';

/**
 * Creates {@link VersionIntroStore} with the root injector, before the profile loads for the first time.
 * Register once, in appConfig.
 */
export function provideVersionIntro(): EnvironmentProviders {
  return provideEnvironmentInitializer(() => {
    inject(VersionIntroStore);
  });
}
